import React, { useState } from "react";
import { Phone, MessageCircle, X } from "lucide-react";

const HelpWidget = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 flex flex-col items-end gap-3 z-50">

      <div className={`flex flex-col items-end gap-3 transition-all duration-300 ease-in-out ${isOpen ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-8 pointer-events-none"}`}>

        <a href="tel:+919274675988" className="flex items-center gap-2 text-white px-3 py-2 rounded-full shadow-lg transition-all" style={{ backgroundColor: "#355931" }} aria-label="Call us now">
          <span className="text-sm font-medium">Need Help? Call Us Now</span>
          <Phone size={16} aria-hidden="true" />
        </a>

        <a href="https://wa.me/919274675988" target="_blank" rel="noopener noreferrer" className="flex items-center bg-white rounded-full shadow-lg overflow-hidden" aria-label="Chat with us on WhatsApp">
          <div className="px-2 py-2 text-gray-700 text-sm">
            Need Help? <span className="font-semibold">Chat with us</span>
          </div>
          <div className="p-2" style={{ backgroundColor: "#ffffff" }}>
            <MessageCircle size={16} className="text-[#335235]" aria-hidden="true" />
          </div>
        </a>

      </div>

      <button onClick={() => setIsOpen(!isOpen)} className="text-white p-3 rounded-full shadow-lg transition-all focus:outline-none" style={{ backgroundColor: "#355931" }} aria-label={isOpen ? "Close help menu" : "Open help menu"} aria-expanded={isOpen}>
        {isOpen ? (
          <X size={20} aria-hidden="true" />
        ) : (
          <MessageCircle size={20} aria-hidden="true" />
        )}
      </button>

    </div>
  );
};

export default HelpWidget;